var recipeCategorySelect = document.querySelector('[data-recipe-category-select]');

function triggerCategory(event) {
  console.log(event);

  console.log('#' + event.target.value);

  var targetedLink = document.getElementById(event.target.value);
  console.log(targetedLink);

  if (!targetedLink) return;

  console.warn(targetedLink);
  window.location.href = targetedLink.href;

  event.preventDefault();
}

if (recipeCategorySelect) {
  recipeCategorySelect.addEventListener('change', triggerCategory);
}
